export function genInteractionCodeMethods(codeObj, cb) {
  // codeObj: {timer, msg, codeCount, disabled}
  if (!codeObj.timer) {
    cb()
    const originMsg = codeObj.msg
    const originCount = codeObj.codeCount
    codeObj.timer = setInterval(() => {
      if (codeObj.codeCount > 0 && codeObj.codeCount) {
        codeObj.disabled = true
        codeObj.codeCount--
        if (codeObj.codeCount !== 0) {
          codeObj.msg = '已发送(' + codeObj.codeCount + ')'
        } else {
          clearInterval(codeObj.timer)
          codeObj.msg = originMsg
          codeObj.codeCount = originCount
          codeObj.timer = null
          codeObj.disabled = false
        }
      }
    }, 1000)
  }
}
